import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { TextStyle, ViewStyle } from 'react-native'
import { Colors } from '../../../util/util'

const styles = (breakpoint: number): any => {
  let overRideContainer: ViewStyle = {}
  let overRideMainContainer: BoxProps = {}
  let overRideHeaderContainer: BoxProps = {}
  let overRideErnContainer: BoxProps = {}
  let overRideExportContainer: BoxProps = {}
  let overRideIconStyle: BoxProps = {}
  let overRideDetailsContainer: BoxProps = {}

  if (breakpoint < 700) {
    overRideContainer = {
      width: '100vw',
    } as ViewStyle
    overRideMainContainer = {
      flexDirection: 'column',
    } as BoxProps
    overRideHeaderContainer = {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      margin: 16,
    } as BoxProps
    overRideErnContainer = {
      // flex: 1,
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      alignSelf: 'auto',
      padding: 0,
    } as BoxProps
    overRideExportContainer = {
      flexDirection: 'row',
      alignSelf: 'flex-start',
    } as BoxProps
    overRideIconStyle = {
      justifyContent: 'center',
      padding: 0,
      margin: 0,
      paddingLeft: 8,
    } as BoxProps

    overRideDetailsContainer = {
      padding: 16,
      margin: 0,
      flexDirection: 'column',
    } as BoxProps
  }

  return {
    container: {
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      shadowColor: Colors.LIGHT_GREY,
      borderRadius: 4,
      zIndex: 4,
      backgroundColor: Colors.WHITE,
      height: '100vh',
      width: 650,
      overflow: 'auto',
      ...overRideContainer,
    } as ViewStyle,
    cellContainer: { flexDirection: 'row', flex: 1 } as ViewStyle,

    leftTitle: {
      // flex: 1,
      textAlign: 'right',
      color: Colors.DARK_GREY,
    } as TextStyle,

    rightTitle: {
      // flex: 1,
    } as TextStyle,
    listHeaderContainer: {
      flexDirection: 'row',
      backgroundColor: 'WHITE',
      borderBottomColor: 'SEPERATOR',
      borderBottomWidth: 2,
      paddingTop: 8,
      paddingBottom: 8,
      margin: 0,
    } as BoxProps,

    listItemContainer: {
      // flex: 1,
      flexDirection: 'row',
      margin: 0,
      paddingVertical: 12,
    } as BoxProps,

    listItemText: {
      // width: 100,
      fontSize: 12,
      fontWeight: 'MEDIUM',
      textAlign: 'center',
      color: 'BLACK_21',
    } as TextProps,

    hoverHeaderText: {
      width: 100,
      fontSize: 10,
      fontWeight: 'BOLD',
      textAlign: 'center',
    } as TextProps,

    detailsContainer: {
      padding: 24,
      margin: 0,
      flexGrow: 1,
      flexDirection: 'column',
      ...overRideDetailsContainer,
    } as BoxProps,

    detailsMainContainer: {
      display: 'flex',
      flexDirection: 'row',
      margin: 0,
      padding: 0,
      justifyContent: 'space-between',
      ...overRideMainContainer,
    } as BoxProps,

    detailsSubContainer: {
      flexDirection: 'column',
      flex: 1,
      margin: 0,
      padding: 0,
      alignSelf: 'baseline',
    } as BoxProps,
    detailsBeneSubContainer: {
      flexDirection: 'column',
      flex: 0.5,
      margin: 0,
      padding: 0,
    } as BoxProps,
    detailsSideContainer: {
      flexDirection: 'row',
      flex: 1,
      margin: 0,
      padding: 0,
    } as BoxProps,
    detailsContent: {
      flexDirection: 'row',
      flex: 1,
      margin: 0,
      padding: 0,
    } as BoxProps,
    detailsBeneContent: {
      flexDirection: 'row',
      flex: 0.5,
      margin: 0,
      padding: 0,
    } as BoxProps,
    headerContainer: {
      // flex: 1,
      padding: 0,
      margin: 24,
      marginRight: 8,
      flexDirection: 'row',
      justifyContent: 'space-between',
      ...overRideHeaderContainer,
    } as BoxProps,
    ernContainer: {
      // flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      margin: 0,
      paddingRight: 10,
      ...overRideErnContainer,
    } as BoxProps,
    exportContainer: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      align: 'center',
      ...overRideExportContainer,
    } as BoxProps,
    list: {
      overflow: 'auto',
    } as ViewStyle,
    iconStyle: {
      justifyContent: 'center',
      padding: 0,
      margin: 0,
      marginRight: 8,
      ...overRideIconStyle,
    } as BoxProps,
    divider: {
      width: 1.1,
      backgroundColor: '#EBEBEB' as ColorOptions,
      marginRight: 16,
      paddingTop: 8,
    } as BoxProps,
    backgroundColor: { backgroundColor: 'WHITE' } as BoxProps,
  }
}

export { styles }
